import { translate } from '@/locales'

const TIME_OPTION_CONFIGS = [
  { key: '00', value: '00:00:00' },
  { key: '01', value: '01:00:00' },
  { key: '02', value: '02:00:00' },
  { key: '03', value: '03:00:00' },
  { key: '04', value: '04:00:00' },
  { key: '05', value: '05:00:00' },
  { key: '06', value: '06:00:00' },
  { key: '07', value: '07:00:00' },
  { key: '08', value: '08:00:00' },
  { key: '09', value: '09:00:00' },
  { key: '10', value: '10:00:00' },
  { key: '11', value: '11:00:00' },
  { key: '12', value: '12:00:00' },
  { key: '13', value: '13:00:00' },
  { key: '14', value: '14:00:00' },
  { key: '15', value: '15:00:00' },
  { key: '16', value: '16:00:00' },
  { key: '17', value: '17:00:00' },
  { key: '18', value: '18:00:00' },
  { key: '19', value: '19:00:00' },
  { key: '20', value: '20:00:00' },
  { key: '21', value: '21:00:00' },
  { key: '22', value: '22:00:00' },
  { key: '23', value: '23:00:00' },
]

const createTimeOptions = (t = translate) =>
  TIME_OPTION_CONFIGS.map(option => ({
    label: t(`timeOptions.${option.key}`),
    value: option.value,
    disabled: false,
  }))

export default createTimeOptions
